import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import { clBasic, clCeldaGrilla, diaMesAno, sizeCelda, sizeEtiqueta } from "./general";
import Boton from "./Boton";

export default function Evaluacion({ filtro, click }) {
  let { firebase } = useContext(AppContext);
  let activo = firebase.proyectoActivo.proyecto;

  const [evaluacion, setEvaluacion] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [change, setChange] = useState(false)

  useEffect(() => {
    setEvaluacion(firebase.evaluacion(activo.id, activo.fechaEvaluacion, filtro));
  }, [filtro, activo.fechaEvaluacion, activo.id, firebase]);

  function actualizarKeyIndicator() {
    if (activo.id) {
      firebase.actualizarKeyIndicator(activo.id, evaluacion, filtro);
      click(); // cerrar ventana, ejecuta la funcion "ampliar" de Estado3dim
    }
    setChange(false)
  }

  return (
    <div style={{ marginLeft: "10px", marginRight: "10px" }}>
      <div style={Scabezal} onClick={() => click()}>
        <div>{`Ultima evaluacion de ${filtro}: ${diaMesAno(activo.fechaEvaluacion)}`}</div>
        <div style={Sradio}><div>Sí</div>  <div>No</div>   </div>
      </div>

      <div style={SlistaItems}>
        {evaluacion.map((e, i) => (
          <div style={SdetalleItem} key={i}>
            <div style={Scelda}>{e.pregunta}</div>
            <div style={Sradio}>
              <input
                type="radio"
                style={{ cursor: "pointer" }}
                value={"s"}
                name={`res${i}`}
                checked={e.evaluacion === "s"}
                onChange={(ev) => {
                  e.evaluacion = ev.target.value;
                  setRefresh(!refresh);
                  setChange(true)
                }}
              ></input>
              <input
                type="radio"
                style={{ cursor: "pointer" }}
                value={"n"}
                name={`res${i}`}
                checked={e.evaluacion === "n"}
                onChange={(ev) => {
                  e.evaluacion = ev.target.value;
                  setRefresh(!refresh);
                  setChange(true)
                }}
              ></input>
            </div>
          </div>
        ))}
      </div>
      <Boton accion={actualizarKeyIndicator} change={change} />
    </div>
  );
}

const SlistaItems = {
  height: "60vh",
  overflowY: "auto",
};

const SdetalleItem = {
  display: "grid",
  gridTemplateColumns: "88%  12% ",
};

const Scabezal = {
  display: "grid",
  gridTemplateColumns: "88%  12% ",
  padding: "8px",
  fontWeight: 700,
  fontSize: sizeEtiqueta,
  borderBottom: "dotted #424242 1px",
  marginTop: "10px",
  height: "6vh",
  color: clBasic,
  cursor: "pointer",
  overflow: "hidden"
};

const Scelda = {
  fontSize: sizeCelda,
  padding: "4px 4px 4px 10px",
  margin: "2px ",
  color: clCeldaGrilla
};

const Sradio = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginRight: "10px",
  fontSize: "1.7vh",
  padding: "4px",

};
